import { Mark, mergeAttributes } from '@tiptap/core'

export interface EmailButtonOptions {
  backgroundColor: string
  color: string
  borderRadius: string
  padding: string
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    emailButton: {
      setEmailButton: (attributes: { href: string }) => ReturnType
      unsetEmailButton: () => ReturnType
    }
  }
}

export const EmailButton = Mark.create<EmailButtonOptions>({
  name: 'emailButton',
  inclusive: false,
  excludes: 'link',

  addOptions () {
    return {
      backgroundColor: '#2563eb',
      color: '#ffffff',
      borderRadius: '6px',
      padding: '10px 16px',
    }
  },

  addAttributes () {
    return {
      href: { default: null },
    }
  },

  parseHTML () {
    return [{ tag: 'a[data-type="email-button"]' }]
  },

  renderHTML ({ HTMLAttributes }) {
    const style = [
      'display:inline-block',
      `background-color:${this.options.backgroundColor}`,
      `color:${this.options.color}`,
      `border-radius:${this.options.borderRadius}`,
      `padding:${this.options.padding}`,
      'font-weight:600',
      'line-height:1.2',
      'text-decoration:none',
    ].join(';')

    return ['a', mergeAttributes(HTMLAttributes, {
      'data-type': 'email-button',
      style,
      target: '_blank',
      rel: 'noopener noreferrer',
    }), 0]
  },

  addCommands () {
    return {
      setEmailButton: attributes => ({ commands }) => commands.setMark(this.name, attributes),
      unsetEmailButton: () => ({ commands }) => commands.unsetMark(this.name),
    }
  },
})
